import bgImage from "@/assets/svgs/clp-blue-beige-pattern-breezy.svg";
import { HeaderVariantWithIcons } from "./type";
import { CLink } from "../customLink/CustomLink";
import NoImageSrc from "@/assets/images/no_image.svg";
import { getCloudinaryURL } from "@/utils/cloudinary";
import { cn } from "@/lib/tailwind";
import { useRef } from "react";
import { useEditsChildWidth } from "@/hooks/useEditsChildWidth";
import CldImage from "@/components/ui/cldImg/CldImage";
import RenderCurrencyInText from "../RenderCurrencyInText";

const WithIcons = ({ icons, background, editType, fontFamily }: HeaderVariantWithIcons) => {
  const iconsRef = useRef(null);
  const { isEditsCenter } = useEditsChildWidth(iconsRef);

  if (!icons?.length) return null;

  const backgroundStyle =
    background === "colorStrip"
      ? { backgroundColor: "#fafafa" }
      : background === "none"
        ? {}
        : bgImage?.src
          ? { backgroundImage: `url(${bgImage.src})`, backgroundSize: "cover" }
          : {};

  return (
    <div
      style={backgroundStyle}
      className="flex h-[8.438rem] w-full items-center justify-center bg-cover sm:h-[12.5rem]"
      ref={iconsRef}
    >
      <div
        className="flex gap-6 overflow-auto pl-6 md:gap-[5.5rem] min-[490px]:justify-center no-scrollbar items-center"
        // className={cn(
        //   "flex w-full items-center justify-center border border-black gap-6 overflow-x-auto pl-6 min-[490px]:justify-center lg:gap-[5.5rem]",
        //   isEditsCenter ? "justify-center" : "justify-start",
        // )}
        style={{ scrollPaddingLeft: "1.5rem", scrollSnapType: "x mandatory" }}
      >
        {icons.map((icon, i) => (
          <div
            key={`icon_${i}_${icon?.label}`}
            className={cn(
              "flex w-[4.063rem] flex-shrink-0 cursor-pointer flex-col items-center space-y-2 text-center sm:w-[5.75rem]",
              icon.active ? "border-[1px] border-tertiary-13" : "",
            )}
            onClick={() => {
              if (icon.handleSelectedEdits !== undefined && icon.index !== undefined) {
                icon.handleSelectedEdits(icon.index);
              }
            }}
          >
            <div className={`flex size-[4.063rem] items-center justify-center ${editType !== "borderless" ? "rounded-full" : ""} sm:size-[5.75rem] overflow-hidden`}>
              <CLink href={icon?.url ?? "#"} className="h-[100%]">
                <CldImage
                  width={92}
                  height={92}
                  src={getCloudinaryURL(icon?.src) ?? NoImageSrc}
                  alt={icon?.alt}
                  className={`h-full object-cover ${editType !== "borderless" ? "rounded-full" : ""}`}
                />
              </CLink>
            </div>
            {icon?.label && (
              <CLink href={icon?.url ?? "#"}>
                <p className="text-center text-[0.75rem]" style={fontFamily ? { fontFamily: fontFamily } : {}} >
                  <RenderCurrencyInText text={icon.label} />
                </p>
              </CLink>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default WithIcons;
